(function () {
  'use strict';

  if (window.SwishPreviewColumn) {
    window.SwishPreviewColumn.init(document);
    return;
  }

  function syncHostTypography(root) {
    if (!root || !document.body || typeof window.getComputedStyle !== 'function') return;

    var probe = null;
    try {
      var bodyStyle = window.getComputedStyle(document.body);
      probe = document.createElement('div');
      probe.setAttribute('aria-hidden', 'true');
      probe.style.cssText = 'position:fixed;left:-10000px;top:0;width:1px;height:1px;overflow:hidden;visibility:hidden;pointer-events:none;contain:layout style;';

      ['h1', 'h2', 'h3', 'h4', 'h0', 'hxl', 'hxxl'].forEach(function (level) {
        var isNativeHeading = /^h[1-6]$/.test(level);
        var heading = document.createElement(isNativeHeading ? level : 'div');
        heading.className = level;
        heading.dataset.swishPreviewTypographyLevel = level;
        heading.textContent = 'Swish';
        heading.style.margin = '0';
        heading.style.padding = '0';
        probe.appendChild(heading);
      });
      document.body.appendChild(probe);

      var headings = {};
      Array.prototype.forEach.call(probe.children, function (heading) {
        headings[heading.dataset.swishPreviewTypographyLevel] = window.getComputedStyle(heading);
      });

      function setValue(name, value) {
        if (value) root.style.setProperty(name, value);
      }

      setValue('--swish-preview-host-body-family', bodyStyle.fontFamily);
      setValue('--swish-preview-host-body-size', bodyStyle.fontSize);
      setValue('--swish-preview-host-body-line-height', bodyStyle.lineHeight);
      setValue('--swish-preview-host-body-weight', bodyStyle.fontWeight);
      setValue('--swish-preview-host-heading-family', headings.h2 && headings.h2.fontFamily);

      ['h1', 'h2', 'h3', 'h4', 'h0', 'hxl', 'hxxl'].forEach(function (level) {
        var style = headings[level];
        if (!style) return;
        setValue('--swish-preview-host-' + level + '-size', style.fontSize);
        setValue('--swish-preview-host-' + level + '-line-height', style.lineHeight);
        setValue('--swish-preview-host-' + level + '-weight', style.fontWeight);
      });

      root.setAttribute('data-swish-preview-host-typography', 'ready');
    } catch (_) {
      try {
        root.setAttribute('data-swish-preview-host-typography', 'fallback');
      } catch (_) {}
    } finally {
      try {
        if (probe && probe.parentNode) probe.parentNode.removeChild(probe);
      } catch (_) {}
    }
  }

  function initializeSlider(root) {
    var list = root && root.querySelector('[data-swish-preview-list]');
    var previousButtons = root
      ? Array.prototype.slice.call(root.querySelectorAll('button[name="previous"]'))
      : [];
    var nextButtons = root
      ? Array.prototype.slice.call(root.querySelectorAll('button[name="next"]'))
      : [];
    if (!list || !previousButtons.length || !nextButtons.length || list.dataset.swishPreviewSliderReady === '1') return;

    var nativeComponent = root.querySelector('slider-component');
    if (nativeComponent && nativeComponent.slider && nativeComponent.nextButton) return;

    list.dataset.swishPreviewSliderReady = '1';
    var currentElement = root.querySelector('.slider-counter--current');
    var totalElement = root.querySelector('.slider-counter--total');
    var resizeTimer = null;
    var pendingPosition = null;

    function positionCourtArrows() {
      if (!root.querySelector('[data-swish-court-dimensions]')) return;
      var viewport = root.querySelector('[data-swish-preview-viewport]');
      var preview = list.querySelector('.swish-preview-column__preview-wrapper');
      if (!viewport || !preview) return;
      var rect = preview.getBoundingClientRect();
      if (rect.height <= 0) return;
      // Keep controls beside the preview, clear of the court dimensions below it.
      var top = rect.top - viewport.getBoundingClientRect().top + rect.height / 2;
      viewport.style.setProperty('--swish-preview-side-arrow-top', top + 'px');
    }

    function getState() {
      var items = Array.prototype.filter.call(
        list.querySelectorAll('.swish-preview-column__item:not([hidden])'),
        function (item) { return item.clientWidth > 0; }
      );
      var maxScroll = Math.max(0, list.scrollWidth - list.clientWidth);
      var firstLeft = items.length ? items[0].getBoundingClientRect().left : 0;
      var positions = [0];
      items.forEach(function (item) {
        var position = Math.min(maxScroll, Math.max(0, item.getBoundingClientRect().left - firstLeft));
        if (position - positions[positions.length - 1] > 1) positions.push(position);
      });
      var currentIndex = nearestIndex(positions, list.scrollLeft);
      return { positions: positions, maxScroll: maxScroll, totalPages: positions.length, currentPage: currentIndex + 1 };
    }

    function nearestIndex(positions, position) {
      return positions.reduce(function (closest, value, index) {
        return Math.abs(value - position) < Math.abs(positions[closest] - position) ? index : closest;
      }, 0);
    }

    function update() {
      var state = getState();
      if (pendingPosition !== null && Math.abs(list.scrollLeft - pendingPosition) <= 1) pendingPosition = null;
      if (currentElement) currentElement.textContent = String(state.currentPage);
      if (totalElement) totalElement.textContent = String(state.totalPages);
      previousButtons.forEach(function (button) {
        button.disabled = list.scrollLeft <= 1;
      });
      nextButtons.forEach(function (button) {
        button.disabled = list.scrollLeft >= state.maxScroll - 1;
      });
    }

    function move(direction) {
      var state = getState();
      var currentIndex = nearestIndex(state.positions, pendingPosition === null ? list.scrollLeft : pendingPosition);
      var nextIndex = Math.max(0, Math.min(state.positions.length - 1, currentIndex + direction));
      pendingPosition = state.positions[nextIndex];
      list.scrollTo({
        left: pendingPosition,
        behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'
      });
    }

    previousButtons.forEach(function (button) {
      button.addEventListener('click', function (event) {
        event.preventDefault();
        move(-1);
      });
    });
    nextButtons.forEach(function (button) {
      button.addEventListener('click', function (event) {
        event.preventDefault();
        move(1);
      });
    });
    list.addEventListener('scroll', update, { passive: true });
    ['pointerdown', 'touchstart', 'wheel'].forEach(function (name) {
      list.addEventListener(name, function () { pendingPosition = null; }, { passive: true });
    });
    function resize() {
      if (resizeTimer) window.clearTimeout(resizeTimer);
      resizeTimer = window.setTimeout(function () {
        syncHostTypography(root);
        pendingPosition = null;
        var state = getState();
        list.scrollTo({ left: state.positions[nearestIndex(state.positions, list.scrollLeft)], behavior: 'instant' });
        positionCourtArrows();
        update();
      }, 100);
    }
    window.addEventListener('resize', function () {
      resize();
    });
    if (window.ResizeObserver) new ResizeObserver(resize).observe(list);
    positionCourtArrows();
    update();
  }

  function initialize(root) {
    if (!root || root.dataset.swishPreviewColumnReady === '1') return;

    root.dataset.swishPreviewColumnReady = '1';
    syncHostTypography(root);
    initializeSlider(root);

    try {
      if (document.fonts && document.fonts.ready && typeof document.fonts.ready.then === 'function') {
        document.fonts.ready.then(function () {
          syncHostTypography(root);
        }).catch(function () {});
      }
    } catch (_) {}

  }

  function initializeAll(scope) {
    var root = scope && scope.matches && scope.matches('[data-swish-preview-column]') ? scope : null;
    if (root) initialize(root);

    var searchRoot = scope && scope.querySelectorAll ? scope : document;
    Array.prototype.forEach.call(searchRoot.querySelectorAll('[data-swish-preview-column]'), initialize);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initializeAll(document); }, { once: true });
  } else {
    initializeAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) { initializeAll(event.target); });
  window.SwishPreviewColumn = { init: initializeAll };
})();
